import { render } from "./IniciarConversaModal.vue?vue&type=template&id=0662b51e&scoped=true"
import script from "./IniciarConversaModal.vue?vue&type=script&lang=js"
export * from "./IniciarConversaModal.vue?vue&type=script&lang=js"

import "./IniciarConversaModal.vue?vue&type=style&index=0&id=0662b51e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0662b51e"]])

export default __exports__